module.exports = __webpack_public_path__ + "img/hj_03.84345b0f.jpg";